import { AnnotationShape } from '../../typings/common';
import { NotificationResult, ValidatorColor } from '../../typings/notification';
import { ResolutionValue } from '../configuration';

export const resolutionValidator = (
  validatorConfiguration: string,
  shape: AnnotationShape,
  printPositionName: string
): NotificationResult | undefined => {
  const validatorName = 'resolutionValidator';

  const resolutionColorsValues: ResolutionValue[] = JSON.parse(
    validatorConfiguration
  );
  if (shape.kind === 'Logo') {
    const { pngHorizontalResolutionDPIs, pngVerticalResolutionDPIs } = shape;

    const lowerDPI =
      pngHorizontalResolutionDPIs <= pngVerticalResolutionDPIs
        ? pngHorizontalResolutionDPIs
        : pngVerticalResolutionDPIs;

    let color: ValidatorColor = 'Green';

    for (const range of resolutionColorsValues) {
      if (lowerDPI >= range.minDPI && lowerDPI <= range.maxDPI) {
        color = convertRangeToColor(range);
        return;
      }

      if (
        pngHorizontalResolutionDPIs > range.maxDPI &&
        pngVerticalResolutionDPIs > range.maxDPI
      ) {
        color = 'Red';
        return;
      }
    }

    return {
      shapeId: shape.id,
      printPositionName,
      validatorName,
      validatorColor: color,
      message: '',
    };
  }
};

const convertRangeToColor = (range: ResolutionValue): ValidatorColor => {
  if (range.color.toLowerCase() === 'red') {
    return 'Red';
  }

  if (range.color.toLowerCase() === 'green') {
    return 'Green';
  }

  if (range.color.toLowerCase() === 'orange') {
    return 'Orange';
  }

  return 'Green';
};
